export default "__VITE_PUBLIC_ASSET__908c4b48__"